import { EBeaconAction } from '@dicetechnology/dice-unity/lib/services/Beacon/types';
import type { MuxVideoMetadata } from '@dicetechnology/doris-plugin-mux';
import type { LoadRequestData } from 'chromecast-caf-receiver/cast.framework.messages';

import { EXPERIMENT } from '../constants';
import { DiceReceiverManager } from '../services';

import { throwError } from './throwError';

interface MuxMetadata {
    mux: {
        data: MuxVideoMetadata;
    };
}

const isInteger = (numberOrString: string | number | undefined): boolean => {
    if (numberOrString == null) {
        return false;
    }
    return Number.isInteger(typeof numberOrString === 'number' ? numberOrString : parseFloat(numberOrString));
};

export const getMuxMetadata = async (loadRequestData: LoadRequestData): Promise<MuxMetadata> => {
    const { media } = loadRequestData;
    const { contentId, metadata } = media;

    const diceReceiverManager = DiceReceiverManager.getInstance();
    const beacon = diceReceiverManager.getBeacon();

    // env_key - MUX Environment Key
    const { muxEnvironmentKey, showContentTitles } = diceReceiverManager.getSettings() ?? throwError('Invalid state!');

    // sub_property_id - Realm
    const realm = diceReceiverManager.getRealm();

    // user_id - User EXID
    const { userId } = await diceReceiverManager.getUserDetails();

    // video_id - Video ID
    let videoId: string | undefined;
    if (isInteger(contentId)) {
        videoId = contentId;
    } else {
        const beaconVideoId = beacon?.getVideoId();
        if (isInteger(beaconVideoId)) {
            videoId = beaconVideoId;
        }
    }

    // video_title - Video Title
    const { title } = metadata as Partial<MediaMetadata>;

    // video_stream_type - Video Stream Type
    const isLive = beacon?.getAction() === EBeaconAction.LIVE;
    const streamType = isLive ? 'live' : 'on-demand';

    // custom_1 - Correlation ID
    const correlationId = beacon?.getCorrelationId();

    return {
        mux: {
            data: {
                env_key: muxEnvironmentKey,
                viewer_user_id: userId,
                sub_property_id: realm,
                video_id: videoId,
                video_title: showContentTitles ? title : videoId,
                video_stream_type: streamType,
                custom_1: correlationId,
                experiment_name: EXPERIMENT
            }
        }
    };
};
